// apps/web/src/components/landing-v2/proofs/PersonalizedProof.tsx
/** Theme 02 / Personalized weather — Cosmic-only. A featured "for you" tile
 *  with an italic headline + body + two pills.  Reference: anonymous .mm
 *  block in Theme 02 (.mm style="background:radial-gradient..."). */
export function PersonalizedProof() {
  return (
    <div
      className="absolute inset-0 flex flex-col p-[18px]"
      style={{
        background:
          'radial-gradient(ellipse at top right, color-mix(in oklab, var(--color-gold-light-legacy) 10%, transparent), transparent 60%)',
      }}
    >
      <span className="inline-flex w-fit items-center rounded-pill border border-gold-light-legacy/30 bg-gold-light-legacy/[0.14] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-gold-light-legacy">
        For you · Pisces moon
      </span>
      <h4
        className="mt-2 font-display text-text-primary"
        style={{ fontSize: '1.05rem' }}
      >
        Soft week. <em className="italic">Don&apos;t push.</em>
      </h4>
      <p className="mt-1 text-[12px] leading-[1.5] text-text-secondary">
        Your moon&apos;s in its own sign through Sunday. Sensitivity is high — that&apos;s
        not a bug, it&apos;s the signal. Use it for the conversation you&apos;ve been
        putting off.
      </p>
      <div className="mt-auto flex gap-2 pt-2">
        <span className="rounded-pill border border-astral-violet/30 bg-astral-violet/[0.16] px-2 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-astral-violet-light">
          Pull a card on this
        </span>
        <span
          className="rounded-pill px-2 py-1 text-[10px] uppercase tracking-[0.14em] text-text-muted"
          style={{
            background: 'var(--hairline-faint)',
            border: '1px solid var(--hairline)',
          }}
        >
          Save
        </span>
      </div>
    </div>
  )
}
